
export const getNestedValue = (obj: any, path: string) => {
  if (!obj || !path) return null;
  return path.split('.').reduce((prev, curr) => (prev ? prev[curr] : null), obj);
};

export const setNestedValue = (obj: any, path: string, value: string) => {
  const newObj = JSON.parse(JSON.stringify(obj)); 
  const keys = path.split('.');
  let current = newObj;
  
  for (let i = 0; i < keys.length - 1; i++) {
    if (!current[keys[i]]) current[keys[i]] = {};
    current = current[keys[i]];
  }
  
  current[keys[keys.length - 1]] = value;
  return newObj;
};

/**
 * 工业级非破坏性深度合并
 * 确保 target 的结构永远完整，只用 source 的有效值进行增量更新
 */
export const deepMerge = (target: any, source: any): any => {
  // 基础类型处理
  if (typeof target !== 'object' || target === null) return source || {};
  if (typeof source !== 'object' || source === null) return target;

  const result = { ...target };

  Object.keys(source).forEach(key => {
    const sourceValue = source[key];
    const targetValue = target[key];

    // 特殊处理：如果 source 的值是空的（{} 或 "" 或 null）
    // 且 target 已经有值了，我们选择保留 target 的值
    if (sourceValue === null || sourceValue === undefined) return;
    if (typeof sourceValue === 'string' && sourceValue.trim() === '' && targetValue) return;
    if (typeof sourceValue === 'object' && !Array.isArray(sourceValue) && Object.keys(sourceValue).length === 0 && targetValue) return;

    if (sourceValue && typeof sourceValue === 'object' && !Array.isArray(sourceValue)) {
      // 递归合并对象
      result[key] = deepMerge(targetValue || {}, sourceValue);
    } else {
      // 覆盖基础值
      result[key] = sourceValue;
    }
  });

  return result;
};
